import {initSurvicate, getSurvicateInstance} from '@survicate/survicate-web-surveys-wrapper/widget_wrapper';
import {useEffect} from "react";
import {useSelector} from "react-redux";
import * as reduxSelectors from "components/store/application.reducers";
import {launchDarkly} from 'utils/launchDarkly';

// Custom event the Survicate survey is configured to trigger on (set in the workspace).
const SURVICATE_APPROVAL_EVENT = 'pnps-approval-event';
// Delay before firing the trigger, so the survey appears a few seconds after the page loads.
const SURVICATE_EVENT_DELAY_MS = 10_000;

export const SurvicateComponent = () => {
    const userData = useSelector(reduxSelectors.getUsersData);
    const loggedInData = useSelector(reduxSelectors.getUsersLoggedInData);
    const language = useSelector(reduxSelectors.getLanguage);

    useEffect(() => {
        const workspaceKey = window.ENVIRONMENT?.SURVICATE_WORKSPACE_KEY;
        if (!workspaceKey) return; // not configured for this environment — skip Survicate
        if (!userData || !loggedInData?.emailAddress) return;

        const config = {
            workspaceKey,
            forcedLanguage: language ?? 'en',
            traits: {
                'user_id': loggedInData?.emailAddress,
                'company_name': userData.companyName
            }
        };
        void initSurvicate(config).catch(e => console.error('Survicate initialization error:', e));

        // Init runs for the nav feedback button (fe-vsn-navigation); only fire the approval survey when its own flag is on.
        if (!launchDarkly.userClient?.variation('fe-enable-survicate', false)) return () => {
        };

        const timer = setTimeout(() => {
            // window._sva is a {} placeholder until web_surveys.js loads; bail if it never did.
            if (typeof window._sva?.invokeEvent !== 'function') {
                console.warn('Survicate SDK not loaded (web_surveys.js blocked?) — event not sent');
                return;
            }
            getSurvicateInstance()?.invokeEvent(SURVICATE_APPROVAL_EVENT);
        }, SURVICATE_EVENT_DELAY_MS);

        return () => clearTimeout(timer);

    }, [userData, loggedInData, language]);

    return null;
};

export default SurvicateComponent;